import React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { ArrowsRotateIcon, SlidersIcon } from '@revfluence/fresh-icons/regular/esm';
import { cn } from '@frontend/shadcn/lib/utils';
import { Spinner } from '../../Analytics/components/ui/spinner';

interface RefreshButtonProps {
  isRefreshing: boolean;
  onClick: () => void;
  dataAttribute?: string;
  disabled?: boolean;
  testId?: string;
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
  isRefreshing,
  onClick,
  dataAttribute = 'refresh-data',
  disabled = false,
  testId = 'refresh-button',
}) => (
  <Button
    size="headerIcon"
    variant="outlineHeader"
    disabled={disabled || isRefreshing}
    onClick={onClick}
    data-testid={testId}
    data-dd-action-name={dataAttribute}
    aria-label={isRefreshing ? 'Refreshing data' : 'Refresh data'}
    aria-busy={isRefreshing}
    className="flex items-center justify-center"
  >
    {isRefreshing ? (
      <Spinner size="sm" spinning />
    ) : (
      <ArrowsRotateIcon className={cn(isRefreshing && 'animate-spin')} />
    )}
  </Button>
);

interface FilterButtonProps {
  onClick: () => void;
  isExpanded: boolean;
  dataAttribute?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  isExpanded,
  dataAttribute = 'open-filters',
}) => (
  <Button
    size="headerIcon"
    variant="outlineHeader"
    onClick={onClick}
    aria-label="Open filters"
    aria-expanded={isExpanded}
    data-dd-action-name={dataAttribute}
  >
    <SlidersIcon aria-hidden="true" />
  </Button>
);
